import { defineAsyncComponent } from 'vue'

/**
 * Maps tool `part.type` to the corresponding component for auto-rendering.
 * Only includes simple tools that accept only a `:part` prop.
 * Interactive tools (showContactForm, showSuggestedReply, showSources,
 * showMultipleChoice) must be wired explicitly in the parent with their
 * required callbacks/events. Consent requests (`requestConfirm` and the tool
 * calls suspended for approval) are not here either: `PkChatbotMessages`
 * renders them all with `PkToolApprovalCard`.
 */
export const toolComponentMap: Record<
    string,
    ReturnType<typeof defineAsyncComponent>
> = {
    requestOAuthConnection: defineAsyncComponent(
        () => import('./PkToolRequestOAuthConnection.vue'),
    ),
    showArtifact: defineAsyncComponent(
        () => import('./PkToolShowArtifact.vue'),
    ),
    showCalendarEvent: defineAsyncComponent(
        () => import('./PkToolShowCalendarEvent.vue'),
    ),
    showComparison: defineAsyncComponent(
        () => import('./PkToolShowComparison.vue'),
    ),
    showContactForm: defineAsyncComponent(
        () => import('./PkToolShowContactForm.vue'),
    ),
    showDiagram: defineAsyncComponent(() => import('./PkToolShowDiagram.vue')),
    showEmail: defineAsyncComponent(() => import('./PkToolShowEmail.vue')),
    showImageGallery: defineAsyncComponent(
        () => import('./PkToolShowImageGallery.vue'),
    ),
    showLocation: defineAsyncComponent(
        () => import('./PkToolShowLocation.vue'),
    ),
    showMessage: defineAsyncComponent(() => import('./PkToolShowMessage.vue')),
    showForm: defineAsyncComponent(() => import('./PkToolShowForm.vue')),
    showMultipleChoice: defineAsyncComponent(
        () => import('./PkToolShowForm.vue'),
    ),
    showProductList: defineAsyncComponent(
        () => import('./PkToolShowProductList.vue'),
    ),
    showQrCode: defineAsyncComponent(() => import('./PkToolShowQrCode.vue')),
    showSources: defineAsyncComponent(() => import('./PkToolShowSources.vue')),
    showSuggestedReply: defineAsyncComponent(
        () => import('./PkToolShowSuggestedReply.vue'),
    ),
    showVideo: defineAsyncComponent(() => import('./PkToolShowVideo.vue')),
    showWeather: defineAsyncComponent(() => import('./PkToolShowWeather.vue')),
    showWebPages: defineAsyncComponent(
        () => import('./PkToolShowWebPages.vue'),
    ),
}
